var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('option',{domProps:{"value":_vm.optionValue,"innerHTML":_vm._s(_vm.fieldsLabel)}})}
var staticRenderFns = []

export { render, staticRenderFns }